import React, { useState } from "react";
import "./Saqlangan.css";

import readingListImg from "../../assets/imgs/reading.png";
import readingListImg2 from "../../assets/imgs/reading2.jpeg";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import RightFixed from "../RightFixed/RightFixed";
import { v4 as uuidv4 } from "uuid";
import ListEach from "./ListEach/ListEach";

export default function Saqlangan({
  savedToList,
  inputVal,
  setInputVal,
  saved,
  setNewList,
  newList,
}) {
  const [addWindow, setAddWindow] = useState(false);

  const addWindowHandler = () => {
    setAddWindow(true);
  };

  const closeModalHandler = () => {
    setAddWindow(false);
  };

  const addNewListHandler = () => {
    setAddWindow(false);
    setNewList([...newList, { name: inputVal, id: uuidv4() }]);
    console.log(newList);
  };

  const changeHandler = (e) => {
    setInputVal(e.target.value);
  };

  return (
    <div className="saqlangan">
      <Modal
        changeHandler={changeHandler}
        inputVal={inputVal}
        closeModalHandler={closeModalHandler}
        addNewListHandler={addNewListHandler}
        addWindow={addWindow}
      />

      <div className="bosh-container">
        <div className="header-flex">
          <h1>Your lists</h1>
          <button onClick={addWindowHandler}>New list</button>
        </div>

        <div className="saved-list">
          <button className="active-save">Saved</button>
          <button>Highlights</button>
        </div>

        <Link className="a-link" to="reading-list-all">
          <div className="reading-list">
            <div className="reading-info">
              <h2>Reading List</h2>
              <div className="view-list">
                <button className="view">View list</button>
                <button className="green">{savedToList.length} stories</button>
              </div>
            </div>

            <div className="rading-img">
              <img src={readingListImg} alt="img" />
              <img src={readingListImg2} alt="img1" />
            </div>
          </div>
        </Link>
        <ul className="ull">
          {newList.map((item, i) => {
            return (
              <Link key={i} to={`../saqlangan/${item.id}`}>
                <div className="reading-list">
                  <div className="reading-info">
                    <h2>{item.name}</h2>
                    <div className="view-list">
                      <button className="view">View list</button>
                      <button className="green"> stories</button>
                    </div>
                  </div>
                  <div className="rading-img">
                    <img src={readingListImg} alt="img" />
                    <img src={readingListImg2} alt="img1" />
                  </div>
                </div>
              </Link>
            );
          })}
        </ul>
      </div>

      <div className="fix-div">
        <RightFixed />
      </div>
    </div>
  );
}
